import { render } from "./ChartController2.vue?vue&type=template&id=0399ebd8&scoped=true"
import script from "./ChartController2.vue?vue&type=script&lang=js"
export * from "./ChartController2.vue?vue&type=script&lang=js"

import "./ChartController2.vue?vue&type=style&index=0&id=0399ebd8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0399ebd8"]])

export default __exports__